import { FC } from 'react';
import { Maps } from '@hopskipdrive/react-components';

interface CareDriverPath {
  path?: google.maps.LatLng[];
}

export const CompletedRoute: FC<CareDriverPath> = ({ path }) => (
  <Maps.Polyline
    data-testid="completed-route-polyline"
    options={{
      path,
      geodesic: true,
      strokeColor: '#1A4A7A',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      zIndex: 2,
    }}
  />
);
